/** @jsxRuntime classic */
import React from 'react';
import { mdx } from '@mdx-js/react'
/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`El estado de nuestra Pokédex tendrá cuatro piezas básicas:`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li"><inlineCode parentName="strong">{`loading`}</inlineCode></strong>{`: Mientras estamos buscando un Pokémon, será verdadero.`}</li>
      <li parentName="ul"><strong parentName="li"><inlineCode parentName="strong">{`error`}</inlineCode></strong>{`: Si ocurre un error en API o un error de red, este será verdadero.`}</li>
      <li parentName="ul"><strong parentName="li"><inlineCode parentName="strong">{`pokemon`}</inlineCode></strong>{`: Guardará todos los datos de nuestro Pokémon.`}</li>
      <li parentName="ul"><strong parentName="li"><inlineCode parentName="strong">{`pokemonID`}</inlineCode></strong>{`: Guardará el ID o el nombre el Pokémon que estamos buscando.`}</li>
    </ul>
    <p>{`Dentro de las 4 versiones de la Pokédex encontrarás un código muy similar a este:`}</p>
    <div {...{
      "className": "remark-highlight"
    }}><pre parentName="div" {...{
        "className": "language-jsx"
      }}><code parentName="pre" {...{
          "className": "language-jsx"
        }}><span parentName="code" {...{
            "className": "token comment"
          }}>{`// Creamos un número aleatorio entre el 1 y el 807`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` `}<span parentName="code" {...{
            "className": "token maybe-class-name"
          }}>{`RandomId`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token known-class-name class-name"
          }}>{`Math`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token method function property-access"
          }}>{`floor`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token known-class-name class-name"
          }}>{`Math`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token method function property-access"
          }}>{`random`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`*`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`806`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`+`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
`}</code></pre></div>
    <p>{`Nosotros creamos un ID aleatorio para tener los datos de Pokémon desde el momento en que se renderiza la Pokédex y utilizamos un número entre el 1 y el 807 porque solo existen 807 Pokémones.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;